import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteGetOurDoctorMessage} from 'data/usecases/private/home/get-our-doctor-message';
import {GetOurDoctorMessage} from 'domain/usecases/private/home/get-our-doctor-message';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {OurDoctorEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetOurDoctorMessage = (): GetOurDoctorMessage =>
	new RemoteGetOurDoctorMessage(
		makeBFFApiUrl(OurDoctorEndpoints.ourDoctor),
		makeAuthorizeHttpClientDecorator(),
	);
